import * as React from "react";
import { SparkLineChart } from "@mui/x-charts";
import { Stack } from "@mui/material";

export default function SimpleLineChart({ data }) {
  const uData = [];
  const xLabels = [];

  // Check if data is an array before using forEach
  if (Array.isArray(data)) {
    data.forEach((element) => {
      uData.push(element.cost);
      xLabels.push(element._id);
    });
  } else {
    return null;
  }

  return (
    <Stack style={{ width: "25%" }}>
      <SparkLineChart
        data={uData}
        xAxis={{
          data: xLabels.map(String),
        }}
        height={100}
        limit
        showTooltip
        showHighlight
      />
    </Stack>
  );
}
